import { CssBaseline, ThemeProvider } from '@mui/material';
import { Loader, theme, Toast } from '@watter/shared-components';
import '@watter/shared-components/src/styles';
import { Amplify } from 'aws-amplify';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { environment } from './environments/environment';
import { LandingPage } from './pages/landing-page';
import { RootState } from './store';
import { forceHideLoader } from './store/reducers/appSlice';
import { openToast, resetToast } from './store/reducers/toastSlice';
import './translations/i18n';
import { NoInternetPopUp } from './components/noInternetPopup/NoInternetPopup';
import { forceSignOutUser } from './service/apolloClient';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolClientId: environment.USER_POOL_CLIENT_ID || '',
            userPoolId: environment.USER_POOL_ID || '',
            identityPoolId: environment.IDENTITY_POOL_ID || '',
        },
    },
    Storage: {
        S3: {
            bucket: environment.S3_BUCKET,
            region: environment.APP_REGION,
        },
    },
});
const App: React.FC = () => {
    const showToast = useSelector((state: RootState) => state.toast);
    const dispatch = useDispatch();

    const closeToast = () => {
        dispatch(resetToast({ show: false, message: null, isAlertOpen: false }));
    };
    const { activeHTTPRequests } = useSelector((state: any) => state.app);

    const hasRunForceHideLoader = React.useRef(false);
    React.useEffect(() => {
        if (!hasRunForceHideLoader.current) {
            console.warn('triggered on hard reload');
            dispatch(forceHideLoader());
            hasRunForceHideLoader.current = true;
        }
    }, [dispatch]);

    React.useEffect(() => {
        if (activeHTTPRequests > 0) {
            const timeout = setTimeout(() => {
                dispatch(forceHideLoader());
            }, 30000);
            return () => {
                clearTimeout(timeout);
            };
        }
        return undefined;
    }, [activeHTTPRequests, dispatch]);
    const { t } = useTranslation();
    React.useEffect(() => {
        const storedVersion = localStorage.getItem('ADMIN_APP_VERSION');
        if (storedVersion && storedVersion !== environment.APP_VERSION) {
            console.warn('admin APP_VERSION changed');
            localStorage.setItem('ADMIN_APP_VERSION', environment.APP_VERSION);
            window.location.reload();
        } else if (!storedVersion) {
            localStorage.setItem('ADMIN_APP_VERSION', environment.APP_VERSION);
        }
    }, []);
    React.useEffect(() => {
        if (localStorage.getItem('adminReduxVersionChanged') === 'true') {
            dispatch(
                openToast({
                    show: true,
                    message: t('user_session_expired_error'),
                    severity: 'error',
                    isAlertOpen: true,
                }),
            );
            forceSignOutUser();
            localStorage.removeItem('adminReduxVersionChanged');
        }
    }, [t, dispatch]);
    return (
        <div className="app">
            {activeHTTPRequests >= 1 && <Loader />}
            <Toast
                open={showToast?.show}
                message={showToast?.message}
                severity={showToast?.severity}
                handleClose={closeToast}
            />
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <LandingPage />
                <NoInternetPopUp />
            </ThemeProvider>
        </div>
    );
};

export { App };
